<template>
  <v-list-item test-tag="tag-116">
    <v-list-item-icon>
      <v-icon v-if="item.sum <= 0">mdi-ticket-percent-outline</v-icon>
      <v-icon v-else>mdi-arrow-up-bold-hexagon-outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{item.name}}</v-list-item-title>
    </v-list-item-content>
    <span>{{item.sum > 0 ? '+' : ''}}{{item.sum.toFixed(2)}}</span>
  </v-list-item>
</template>

<script>
export default {
  props: ['item']
}
</script>